import React from "react";
import "./IndustryBannerBgSection.scss";
import Flotas_Laptop from "../../../assets/img/Flotas_Laptop.png";

const IndustryBannerBgSection = ({ children, route, laptopImg }) => {
  return (
    <div className={`industryBannerBgSection-container ${route}`}>
      <div
        className={`all-height`}
      >
        {children}
      </div>
      {laptopImg && (
        <div className="flex all-width center-content-items industryBannerBgSection-flotas-laptop-container">
          <img src={Flotas_Laptop} alt="Laptop" />
        </div>
      )}
    </div>
  );
};

export default IndustryBannerBgSection;
